import PropTypes from 'prop-types'
import React, { Component } from 'react'
import FriendsHeader from './FriendsHeader'
import styles from './_friendGlobal.css'
import findFriendStyles from './_findFriends.css'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import * as friendActions from 'services/friends/actions'
import * as friend from 'services/friends/selectors'
import * as user from 'services/user/selectors'
import FriendPending from './FriendPending'
import FriendSuggested from './FriendSuggested'
import { FormattedMessage } from 'react-intl'
import ItemRow from 'components/layout/ItemRow'
import Button from 'components/util/Button'
import { Row, Col } from 'react-flexbox-grid'
import Loader from 'components/util/Loader'

const mapStateToProps = (state) => ({
  findFriendsLoading: friend.selectFindFriendsLoading(state),
  pendingFriendRequests: friend.selectPendingFriendRequests(state),
  suggestedFriends: friend.selectSuggestedFriends(state),
  userId: user.selectUserId(state),
  searchResults: friend.selectSearchResults(state),
  searchLoading: friend.selectSearchLoading(state),
  noSearchResults: friend.selectNoSearchResults(state),
  userIdCurrentlyAdding: friend.selectUserIdCurrentlyAdding(state),
  isGettingMoreSuggestedFriends: friend.selectSuggestedFriendsLoading(state),
  noMoreSuggestions: friend.selectNoMoreSuggestions(state),
})

const mapDispatchToActions = {
  ...friendActions,
  push,
}

export class FindFriends extends Component {
  static propTypes = {
    findFriendsLoading: PropTypes.bool,
    pendingFriendRequests: PropTypes.array,
    getFindFriendsData: PropTypes.func,
    suggestedFriends: PropTypes.array,
    removeOrDenyFriend: PropTypes.func,
    userId: PropTypes.number,
    addFriend: PropTypes.func,
    searchUsers: PropTypes.func,
    searchResults: PropTypes.array,
    searchLoading: PropTypes.bool,
    noSearchResults: PropTypes.bool,
    userIdCurrentlyAdding: PropTypes.number,
    isGettingMoreSuggestedFriends: PropTypes.bool,
    getMoreSuggestedFriends: PropTypes.func,
    resetFriendApiOffsets: PropTypes.func,
    noMoreSuggestions: PropTypes.bool,
  };

  state = {
    searchInput: '',
  }

  componentWillMount () {
    const { userId } = this.props
    this.props.resetFriendApiOffsets()
    this.props.getFindFriendsData(userId)
  }

  handleCancelPendingFriendRequest = (requestToCancelId) => {
    const { userId } = this.props
    this.props.removeOrDenyFriend(requestToCancelId, userId)
  }

  handleAddFriend = (friendInfo) => {
    const { userId } = this.props
    this.props.addFriend(friendInfo, userId)
  }

  handleSearchInputChange = (e) => {
    this.setState({
      searchInput: e.target.value,
      searchInputRequired: false,
    })
  }

  handleFindKeypress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
    }
  }

  handleSearch = () => {
    const { searchInput } = this.state
    const { userId } = this.props

    this.setState({
      searchInputRequired: false,
    })

    if (searchInput.length) {
      this.props.searchUsers(this.state.searchInput, userId)
    } else {
      this.setState({
        searchInputRequired: true,
      })
    }
  }

  handleMoreSuggestedFriends = () => {
    const { userId } = this.props
    this.props.getMoreSuggestedFriends(userId)
  }

  render () {
    const {
      pendingFriendRequests,
      suggestedFriends,
      searchResults,
      searchLoading,
      noSearchResults,
      userIdCurrentlyAdding,
      findFriendsLoading,
      isGettingMoreSuggestedFriends,
      noMoreSuggestions } = this.props

    const searchResultNodes = searchResults.map((friendResult, i) =>
      <FriendSuggested
        key={i}
        friendInfo={friendResult}
        idInLoadingState={userIdCurrentlyAdding}
        addFriendAction={(friendIdToAdd) => this.handleAddFriend(friendIdToAdd)} />
    )

    const suggestedFriendNodes = suggestedFriends.map((suggestedFriend, i) =>
      <FriendSuggested
        key={i}
        friendInfo={suggestedFriend}
        idInLoadingState={userIdCurrentlyAdding}
        addFriendAction={(friendIdToAdd) => this.handleAddFriend(friendIdToAdd)} />
    )

    const pendingFriendNodes = pendingFriendRequests.map((pendingFriend, i) =>
      <FriendPending
        key={i}
        friendInfo={pendingFriend}
        cancelFriendRequestAction={(userIdToCancel) => this.handleCancelPendingFriendRequest(userIdToCancel)} />
    )

    return (
      <div className={styles.friendPageContainer}>
        <FriendsHeader />

        <div className={findFriendStyles.friendSearchContainer}>
          <h3 className={styles.friendSectionHeader}>
            <FormattedMessage
              id='friends.searchheader'
              defaultMessage='Find MapMyFitness Friends by first name, last name, or email:' />
          </h3>
          <div className={findFriendStyles.searchBar}>
            <Row>
              <Col xs={12} sm={9}>
                <input
                  className={findFriendStyles.searchInput}
                  value={this.state.searchInput}
                  onChange={this.handleSearchInputChange}
                  onKeyPress={this.handleFindKeypress} />

                {this.state.searchInputRequired ?
                  <div className={findFriendStyles.searchValidationMessage}>
                    <FormattedMessage
                      id='friends.searchvalidationerror'
                      defaultMessage='Please enter a name or email...' />
                  </div> : null}
              </Col>
              <Col xs={12} sm={3}>
                <Button
                  size='small'
                  type='action'
                  el='button'
                  className={findFriendStyles.searchButton}
                  disabled={searchLoading}
                  onClick={this.handleSearch}>
                  <FormattedMessage
                    id='friends.searchbutton'
                    defaultMessage='Search'
                    />
                </Button>
              </Col>
            </Row>
          </div>
          {searchLoading ?
            <div style={{ textAlign: 'center' }}>
              <Loader type='spin' height={50} width={50} />
            </div> : null}
          {noSearchResults ?
            <div className={findFriendStyles.noSearchResults}>
              <FormattedMessage
                id='friends.nosearchresults'
                defaultMessage='We did not find any results.  Please double check your search and try again.' />
            </div> : null}
          <ItemRow nodes={searchResultNodes} cols={2} />
        </div>
        {!findFriendsLoading ?
          <div>
            {pendingFriendRequests.length ?
              <div className={findFriendStyles.pendingFriendsContainer}>
                <h3 className={styles.friendSectionHeader}>
                  <FormattedMessage id='friends.pendingrequests' defaultMessage='Pending Friend Requests' />
                </h3>
                <ItemRow nodes={pendingFriendNodes} cols={2} />
              </div>
            : null}

            {suggestedFriends.length ?
              <div>
                <div>
                  <h3 className={styles.friendSectionHeader}>
                    <FormattedMessage id='friends.suggested' defaultMessage='Suggested Friends' />
                  </h3>
                  <ItemRow nodes={suggestedFriendNodes} cols={2} />
                </div>
                <div className={findFriendStyles.moreSuggestedFriendsButton}>
                  {!isGettingMoreSuggestedFriends && !noMoreSuggestions ?
                    <Button
                      size='small'
                      el='button'
                      className={findFriendStyles.searchButton}
                      disabled={searchLoading}
                      onClick={this.handleMoreSuggestedFriends}>
                      <FormattedMessage
                        id='friends.moresuggestedfriends'
                        defaultMessage='View More'
                        />
                    </Button> : null}
                  {isGettingMoreSuggestedFriends ? <Loader type='spin' height={35} width={35} /> : null}
                  {noMoreSuggestions ?
                    <FormattedMessage
                      id='friends.nomoresuggestions'
                      defaultMessage='We could not find any more suggestions' /> : null}
                </div>
              </div>
            : null}
          </div>
          :
            <div style={{ textAlign: 'center' }}>
              <Loader type='spin' height={50} width={50} />
            </div>}
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(FindFriends)



// WEBPACK FOOTER //
// ./src/components/friends/FindFriends.jsx